import React from 'react';
import {string, func, any} from 'prop-types';

const RitIconButton = ({ labelClass, children, onClick }) => {
  return (
    <label
      className={labelClass}
      onClick={onClick}
    >
      {children}
    </label>
  )
}

RitIconButton.propTypes = {
  labelClass: string,
  children: any,
  onClick: func.isRequired,
}

export default RitIconButton;